var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ProfessionalMyPageTopView } from '@/components/pages/mypage/professional/ProfessionalMyPageTop/ProfessionalMyPageTopView';
import { useHotlineProNewListFetch } from '@/feature/hotline/professional/mypage/hook/useHotlineProNewListFetch';
import { useHotlineProScheduledFetch } from '@/feature/hotline/professional/mypage/hook/useHotlineProScheduledFetch';
import { canUseHotlineProUser } from '@/feature/hotline/professional/util/canUseHotlineUser';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { useMyPageRfpOffered } from '@/pages/mypage/professional/rfp/useMyPageRfpOffered';
import { useMyPageRfpProposal } from '@/pages/mypage/professional/rfp/useMyPageRfpProposal';
import { useMyPageRfpUnread } from '@/pages/mypage/professional/rfp/useMyPageRfpUnread';
import { useMyPageBanner } from '@/pages/mypage/professional/useMyPageBanner';
import { isClient, isFreeProfessional, } from '@/utils/resources/auth/authResource';
import { getFullName, getOrganizationName, getPosition, isCanUseProfessionalProffit, isCanUseProfessionalProffitMart, isCanUseProfessionalSeminar, isUnderExaminationProfessionalOrganizationProffit, isProfessionalPreStatus, } from '@/utils/resources/profile/profileResource';
/**
 * コンサルタント：マイページTOP
 * @constructor
 */
export const ProfessionalMyPageTop = (props) => {
    var _a, _b, _c, _d;
    const { profile } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { auth, news } = useTypeSelector((rootState) => ({
        auth: rootState.auth,
        news: rootState.news,
    }));
    // バナー一覧取得
    const { fetchList: fetchBannerList, list: bannerList, onClickBanner, onDisplayBanner, } = useMyPageBanner({
        dispatch,
        unmountRef,
    });
    // ホットライン一覧：新着
    const { fetchNewListData, isLoading: hotlineNewListLoading, list: hotlineNewList, } = useHotlineProNewListFetch({
        dispatch,
        unmountRef,
    });
    // ホットライン一覧：今後の相談予定
    const { fetchScheduledListData, isLoading: hotlineScheduledListLoading, list: hotlineScheduledList, } = useHotlineProScheduledFetch({
        dispatch,
        unmountRef,
    });
    const userProps = useMemo(() => {
        var _a;
        return ({
            canUseHotline: canUseHotlineProUser(profile, auth),
            fullName: getFullName(profile),
            image: (_a = profile.information) === null || _a === void 0 ? void 0 : _a.file,
            isFree: isFreeProfessional(auth),
            isPre: isProfessionalPreStatus(profile),
            isUseProffit: isCanUseProfessionalProffit(profile),
            isUseProffitMart: isCanUseProfessionalProffitMart(profile),
            isUseProffitRequest: isUnderExaminationProfessionalOrganizationProffit(profile),
            isUseSeminar: isCanUseProfessionalSeminar(profile),
            organizationName: getOrganizationName(profile),
            position: getPosition(profile, isClient(auth)),
        });
    }, [auth, profile]);
    const args = { dispatch, isUseProffit: userProps.isUseProffit, unmountRef };
    const rfpProposal = useMyPageRfpProposal(args);
    const rfpUnread = useMyPageRfpUnread(args);
    const rfpOffered = useMyPageRfpOffered(args);
    // ホットライン データ取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            // 利用不可の場合は新着のみ取得
            if (userProps.canUseHotline) {
                yield Promise.all([fetchNewListData(), fetchScheduledListData()]);
            }
            else {
                yield fetchNewListData();
            }
        }))();
    }, [fetchNewListData, fetchScheduledListData, userProps]);
    // バナー一覧 データ取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (bannerList)
                return;
            yield fetchBannerList();
        }))();
    }, [bannerList, fetchBannerList]);
    return (_jsx(ProfessionalMyPageTopView, { bannerList: bannerList || [], hotlineNewList: hotlineNewList, hotlineNewListLoading: hotlineNewListLoading, hotlineScheduledList: hotlineScheduledList, hotlineScheduledListLoading: hotlineScheduledListLoading, news: news.list, onClickBanner: onClickBanner, onDisplayBanner: onDisplayBanner, profile: profile, rfpOffered: {
            list: (_a = rfpOffered.data) === null || _a === void 0 ? void 0 : _a.payload.list,
            loading: rfpOffered.loading,
            onPageChange: rfpOffered.onPageChange,
            page: rfpOffered.page,
            pageCount: ((_b = rfpOffered.data) === null || _b === void 0 ? void 0 : _b.total)
                ? Math.ceil(rfpOffered.data.total / 4)
                : undefined,
        }, rfpProposal: {
            list: (_c = rfpProposal.data) === null || _c === void 0 ? void 0 : _c.payload.list,
            loading: rfpProposal.loading,
        }, rfpUnread: {
            list: (_d = rfpUnread.data) === null || _d === void 0 ? void 0 : _d.payload.list,
            loading: rfpUnread.loading,
        }, user: userProps }));
};
